/**
 * Configura el servicio de autenticacion del visor con el token del enlace.
 *
 * La LIMPIEZA de la URL ya NO se hace aqui: se hace en EncryptedParamsContext
 * cuando la validacion termino. Si se borra el token antes, el validador recibe
 * los parametros sin token y responde "Enlace no valido" aunque sea correcto.
 *
 * @param token - The token to set in the user authentication service.
 * @param location - The location object from the router (se conserva por compatibilidad).
 * @param userAuthenticationService - The user authentication service instance.
 */
export function updateAuthServiceAndCleanUrl(
  token: string,
  _location: any,
  userAuthenticationService: any
): void {
  if (!token) {
    return;
  }

  // if a token is passed in, set the userAuthenticationService to use it
  // for the Authorization header for all requests
  userAuthenticationService.setServiceImplementation({
    getAuthorizationHeader: () => ({
      Authorization: 'Bearer ' + token,
    }),
  });
}
